import { PropsWithChildren } from 'react';
import { BootAwareLoader } from './components/Loader/BootLoader';
import { useAccountSwitcher } from './services/hooks/useAccountSwitcher';
import { useCustomerTenantSync } from './services/hooks/useCustomerTenantSync';

/**
 * Holds the app back until the token's account is lined up with the subdomain, so Maggie's first call
 * carries a token for an account that gives the user access to it. A failed or timed-out check lets the
 * app load on the token it has, with an error toast.
 */
export function AccountGate({ children }: PropsWithChildren) {
  useCustomerTenantSync();
  const { isCheckingAccount } = useAccountSwitcher();

  if (isCheckingAccount) {
    return <BootAwareLoader height='90vh' />;
  }
  return <>{children}</>;
}
